module.exports = __webpack_public_path__ + "img/fn-3.5b8d811.svg";